// extracted by mini-css-extract-plugin
export var addButton = "_cr-0";
export var border = "_cr-8";
export var check = "_cr-h";
export var danger = "_cr-6";
export var dropdownContainer = "_cr-1";
export var editModalBody = "_cr-j";
export var footerContainer = "_cr-i";
export var fullWidth = "_cr-a";
export var hide = "_cr-9";
export var icon = "_cr-3";
export var input = "_cr-7";
export var inputFlex = "_cr-b";
export var inputWrapper = "_cr-c";
export var manualFocus = "_cr-5";
export var optionButton = "_cr-4";
export var pillWrapper = "_cr-e";
export var pointer = "_cr-2";
export var showOverflow = "_cr-f";
export var tagsFlex = "_cr-d";
export var xButton = "_cr-g";